import type { RadioProps } from 'antd';
import { Radio } from 'antd';
import classNames from 'classnames';
import React from 'react';

import { Actions, Thumbnail, Wrapper } from 'components/ui/_styles/Radio';
import type { DeleteProps } from 'components/ui/base/MediaGallery/components/Delete';
import Delete from 'components/ui/base/MediaGallery/components/Delete';
import Download from 'components/ui/base/MediaGallery/components/Download';

import type { ImageMedia } from 'modules/medias/types/image-media';

export type RadioMediaProps = RadioProps & {
  selectedId: string;
  onDelete?: () => void;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  onDownload?: () => void;
  media: ImageMedia;
  deleteProps?: DeleteProps;
  'data-cy'?: string;
};

const RadioMedia: React.FC<RadioMediaProps> = ({
  selectedId,
  onDelete,
  onDownload,
  media,
  onClick,
  deleteProps,
  'data-cy': dataCy,
  ...props
}) => {
  const { id, path, thumbnailPath, originalPath } = media;
  const selected = selectedId === id;
  const thumbnail = thumbnailPath ?? path ?? originalPath;

  return (
    <Wrapper
      data-cy={dataCy}
      className={classNames({ 'opacity-5': !selected, 'border-primary': selected })}
    >
      <Thumbnail data-cy="thumbnail" path={thumbnail} onClick={onClick} />
      <Actions>
        <Radio data-cy="radio" {...props} />
        {onDownload && <Download onDownload={onDownload} />}
        {onDelete && <Delete {...deleteProps} onDelete={onDelete} />}
      </Actions>
    </Wrapper>
  );
};

export default RadioMedia;
